<template>
  <div class="thread">
    <div class="thread__back">
      <small>
        <a
          href="#"
          @click="$emit('close')"
        >

          <span class="fa fa-angle-left" /> {{ trans('core.back') }}
        </a>
        <span v-if="subscribable != null"> &nbsp; {{ subscribable.name }} </span>
      </small>
    </div>
    <div class="thread__messages">
      <template v-for="message in messages">
        <Message :message="message" />
      </template>
      <template v-if="advise.completed">
        <span
          class="badge-success badge"
          style="margin-top:10px"
        >{{ trans('core.closed') }}</span>
      </template>
    </div>
    <div
      v-if="advise.completed === false"
      class="thread__create"
    >
      <CreateMessage
        :advise="advise"
        @closeAdvise="$emit('close')"
      />
    </div>
  </div>
</template>

<script>

import CreateMessage from '@/students/subscriptions/components/advise/CreateMessage'
import Message from '@/students/subscriptions/components/advise/Message'
export default {
  name: 'AdviseThread',
  components: { CreateMessage, Message },
  props: {
    advise: {
      required: true,
    },
    subscribable: {
      required: false,
      default: null,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    messages () {
      return this.advise.messages.map(id => this.$store.state.advises.messages[id])
    },
  },

}

</script>

<style scoped lang="scss">
.thread{
  display: flex;
  max-height: 100%;
  flex-direction: column;
  margin-bottom: 20px;

  &__back {
    flex: 0 1 30px;
    border-bottom: 1px solid #eee;
  }
  &__messages {
    flex: 1 1 auto;
    overflow-y: auto;
    max-height: 500px;
  }
  &__create {
    flex: 0 0 auto;
  }
}
</style>
